import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 50px; 
      height: 55px;
    }`
  }
`


const ChartPieIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG id="chart_pie" xmlns="http://www.w3.org/2000/svg" width="70.043" height="70.042" isFromWidgetChoice={isFromWidgetChoice} viewBox="0 0 70.043 70.042">
      <g id="Groupe_2989" data-name="Groupe 2989">
        <g id="Groupe_2988" data-name="Groupe 2988">
          <path className="fillHoverSVG" id="Tracé_1253" data-name="Tracé 1253" d="M32.1,54.4v-31.6a1.46,1.46,0,0,0-1.459-1.459C13.746,21.333,0,36.389,0,54.895A33.6,33.6,0,0,0,33.562,88.457c8.28,0,12.759-1.5,18.439-6.17a1.46,1.46,0,0,0,.225-2.022Zm1.459,31.143A30.677,30.677,0,0,1,2.918,54.9c0-16.355,11.653-29.759,26.266-30.6V54.9a1.45,1.45,0,0,0,.309.9L49.035,80.916C44.427,84.436,40.584,85.539,33.562,85.539Z" transform="translate(0 -18.415)" fill="#787878"/>
          <path className="fillHoverSVG" id="Tracé_1254" data-name="Tracé 1254" d="M257.459,35.021h32.1a1.46,1.46,0,0,0,1.459-1.459A33.6,33.6,0,0,0,257.459,0,1.46,1.46,0,0,0,256,1.459v32.1A1.46,1.46,0,0,0,257.459,35.021Zm1.459-32.068A30.684,30.684,0,0,1,288.068,32.1H258.918Z" transform="translate(-220.979)" fill="#787878"/>
          <path className="fillHoverSVG" id="Tracé_1255" data-name="Tracé 1255" d="M307.967,277.333H278.782a1.458,1.458,0,0,0-1.135,2.376l18.97,23.485a1.45,1.45,0,0,0,1.033.54c.035,0,.067,0,.1,0a1.468,1.468,0,0,0,1-.391,33.692,33.692,0,0,0,10.678-24.553A1.46,1.46,0,0,0,307.967,277.333Zm-10.089,22.776-16.04-19.857h24.635A30.79,30.79,0,0,1,297.878,300.109Z" transform="translate(-239.383 -239.393)" fill="#787878"/>
        </g>
      </g>
    </SVG>
  </IconContainer>
)

export default ChartPieIcon